import React from "react";
import AppDialog, {
  TextButton,
  WarningAction,
} from "../../../../components/molecules/dialog";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isEmpty, isArray } from "lodash";

const DeleteEmailModal = ({
  showModal,
  onClickPrimaryAction,
  closeModal,
  loading,
}) => {
  const { authAccount } = useSelector((state) => state.application);
  const { t } = useTranslation();

  const emailIncludedKeys = ["email", "email_sms"];

  const warningMessage =
    !isEmpty(authAccount.pushNotificationPreferences) &&
    isArray(authAccount.pushNotificationPreferences) &&
    authAccount.pushNotificationPreferences.some((element) =>
      emailIncludedKeys.includes(element.option.id)
    )
      ? t("accountPage.notificationPreferencesResetWarning")
      : t("accountPage.emailDeleteConfimationMessage");

  return (
    <AppDialog
      showModal={showModal}
      initialized={true}
      onCloseModal={closeModal}
      closeOnOutsideClick={true}
      title={t("accountPage.removeEmailModalTitle")}
    >
      <Grid container className="row-gap-16 p-16">
        <Typography variant="body2">
          {warningMessage}
          {/* {t("accountPage.notificationPreferencesResetWarning")} */}
        </Typography>
        <Grid
          item
          container
          justifyContent="flex-end"
          className="column-gap-8"
          wrap="nowrap"
        >
          <TextButton label={t("common.cancel")} onClick={closeModal} />
          <WarningAction
            onClick={onClickPrimaryAction}
            label={t("accountPage.removeEmail")}
            processing={loading}
            disabled={loading}
          />
        </Grid>
      </Grid>
    </AppDialog>
  );
};

export default DeleteEmailModal;
